
export function isFacebookAndroidWebview() {
  const ua = window?.navigator.userAgent || window?.navigator.vendor || window.opera;
  return ua.indexOf('Android') > -1 && (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1);
}
